import { lazy } from 'react';

import { AccountScreen, ACCOUNT_SCREEN_PATHS } from 'common/accountActivationAndRecovery/AccountScreen';

import OktaLoginCallback from './okta/OktaLoginCallback';
import OktaPostLoginCallback from './okta/OktaPostLoginCallback';
import OktaPostLogoutCallback from './okta/OktaPostLogoutCallback';

export const routes = [
    { component: OktaLoginCallback, permissions: [], path: '/sso/okta' },
    { component: OktaPostLoginCallback, permissions: [], path: '/sso/okta/postLogin' },
    { component: OktaPostLogoutCallback, permissions: [], path: '/sso/okta/logout' },
    {
        component: lazy(() => import('module/auth/login/selectUserLevelRole/SelectUserLevelRolePage')),
        permissions: [],
        path: '/selectRole',
    },
    {
        component: lazy(() => import('module/auth/login/selectRoleView/SelectRoleViewPage')),
        permissions: [],
        path: '/selectRoleView',
    },
    {
        component: lazy(() => import('module/auth/forgotUser/forgotUser.page')),
        permissions: [],
        path: ACCOUNT_SCREEN_PATHS[AccountScreen.ForgotUser],
    },
    {
        component: lazy(() => import('module/auth/security_question/security_question')),
        permissions: [],
        path: ACCOUNT_SCREEN_PATHS[AccountScreen.SecurityQuestion],
    },
    {
        component: lazy(() => import('module/auth/security_question/security_answers/security_answers')),
        permissions: [],
        path: ACCOUNT_SCREEN_PATHS[AccountScreen.SecurityAnswer],
    },
    {
        component: lazy(() => import('module/auth/login/createpass/create_password')),
        permissions: [],
        path: ACCOUNT_SCREEN_PATHS[AccountScreen.CreatePassword],
    },
    {
        component: lazy(() => import('module/auth/security_question/security_answers/security_answers')),
        permissions: [],
        path: '/resetPassword',
    },
    {
        component: lazy(() => import('module/auth/dashboard/dashboard.page')),
        permissions: [],
        path: '/dashboard',
    },
];
